import { render, staticRenderFns } from "./ChatAssignment.vue?vue&type=template&id=94494f02&scoped=true&"
import script from "./ChatAssignment.vue?vue&type=script&lang=js&"
export * from "./ChatAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ChatAssignment.vue?vue&type=style&index=0&id=94494f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94494f02",
  null
  
)

export default component.exports